import { render } from "./MainParagraph.vue?vue&type=template&id=a081f574&scoped=true"
import script from "./MainParagraph.vue?vue&type=script&lang=js"
export * from "./MainParagraph.vue?vue&type=script&lang=js"

import "./MainParagraph.vue?vue&type=style&index=0&id=a081f574&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a081f574"]])

export default __exports__